/**
 * Returns the string 's' unless the given value is 1.
 *
 * @param {number|string} count
 * @return {string}
 */
const pluralSFilter = (count) => (parseInt(count, 10) === 1 ? '' : 's');

module.exports = pluralSFilter;
